/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import DashboardPage from './components/dashboard';
import SellerEvaluation from './components/seller-evaluation';
import NotAllowed from 'src/permissions/not-allowed';
import Restricted from 'src/permissions/restricted';

const DashboardWrapper: FC = () => {
  return (
    <Switch>
      <Route path="/dashboard" exact>
        <Restricted to="ROLE_MC_DASHBOARD" fallback={<NotAllowed />}>
          <DashboardPage />
        </Restricted>
      </Route>
      <Route path="/dashboard/seller-evaluation" exact>
        <SellerEvaluation />
      </Route>
    </Switch>
  );
};

export { DashboardWrapper };
